import React, {Component} from 'react'
import styles from  './footer.module.css';
import fb from './assets/fb.svg';
import instagram from './assets/instagram.svg';
import youtube from './assets/youtube.svg';
import twitter from './assets/twitter-text.svg';
import { List, Container, Grid, Image, } from 'semantic-ui-react';

const Brand = () => {
  return <div>
     <div className={styles.declare}>
       <span>2018 © All Rights Reserved.</span>
     </div>
     <div className={styles.declare}>
       <span>Uni Village Education</span>
     </div>
     </div>
}

const Hidden = ({col}) => {
  const hidden = { visibility: 'hidden' };
  return <Span columns={8}><div style={hidden}>-</div></Span>
}

const Footer = () => {
  const icons = [
    { icon: fb, url: 'https://fb.me/univillage.co' },
    { icon: instagram, url: 'https://www.instagram.com/univillageedu/' },
    { icon: youtube, url: 'https://www.youtube.com/channel/UCfNzjgBZzcQr5axNjdPanXQ' },
    { icon: twitter, url: 'https://twitter.com/univillageedu' }
  ];
  const links = [
    { title:'About', url: '/' },
    { title:'Contact', url: '/' },
    { title:'Blog', url: '/' },
    { title:'Privacy', url: '/privacy' }];

  return  <Container fluid textAlign='center' className={styles.footer}>
  <Grid>
  <Grid.Row>
    <Grid.Column width={2} />
    <Grid.Column width={12}>
     <List horizontal size="tiny" >
      {icons.map(({icon, url}, i) => {
        return <List.Item key={"logo-" + i}>
            <Image src={icon} href={url} />
          </List.Item>
      })}
      </List>
      </Grid.Column>
      <Grid.Column width={2} />
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={2} />
      <Grid.Column width={12}>
       <List horizontal size="tiny" >
        {links.map(({title, url}, i) => {
          return <List.Item key={"link-" + i}>
              <p>{title}</p>
            </List.Item>
        })}
        </List>
        </Grid.Column>
        <Grid.Column width={2} />
      </Grid.Row>

    </Grid>
    </Container>
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js